module.exports = __webpack_public_path__ + "static/media/plus-prata.ccc89de9.jpg";